import 'isomorphic-fetch';
import {
    CALL_API,
    API_ROOT,
    METHOD_PUT,
    METHOD_POST,
    METHOD_GET,
    METHOD_PATCH,
    METHOD_DELETE,
    TYPE_FORM
} from './middleware/api';
import {saveData, SESSION_KEY} from './storage/local-storage';
import {CLIENT_ID, CLIENT_SECRET} from './config';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

function requestLogin(creds) {
    return {
        type: LOGIN_REQUEST,
        creds
    };
}

function receiveLogin(session) {
    return {
        type: LOGIN_SUCCESS,
        message: `Successfully logged`,
        session
    };
}

function loginError(error) {
    return {
        type: LOGIN_FAILURE,
        error
    };
}

// TODO: re-factor
// possible candidate to generalize with api middleware
export function loginUser(creds) {
    const {username, password} = creds;
    const formData = [];
    formData.push(`username=${encodeURIComponent(username)}`);
    formData.push(`password=${encodeURIComponent(password)}`);
    formData.push('grant_type=password');
    formData.push(`client_id=${CLIENT_ID}`);
    formData.push(`client_secret=${CLIENT_SECRET}`);
    formData.push('scope=*');

    let config = {
        method: METHOD_POST,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        body: formData.join('&')
    };

    return dispatch => {
        dispatch(requestLogin(creds));
        return fetch('/oauth/token', config).then(res => {
            return res.json().then(json => ({res, json}));
        }).then(({res, json}) => {
            if (!res.ok) {
                const {status} = res;
                return Promise.reject({status, ...({res: json})});
            }
            saveData(SESSION_KEY, json);
            dispatch(receiveLogin(json));
            dispatch(fetchMe());
        }).catch(error => dispatch(loginError(error.res)));
    }
}

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

function requestLogout() {
    return {
        type: LOGOUT_REQUEST
    };
}

function receiveLogout() {
    return {
        type: LOGOUT_SUCCESS,
        message: `Successfully logged out`
    }
}

export const RESET_ME = 'RESET_ME';
function resetMe() {
    return {
        type: RESET_ME
    }
}

export function logoutUser() {
    return dispatch => {
        dispatch(requestLogout());
        localStorage.removeItem(SESSION_KEY);
        dispatch(receiveLogout());
        dispatch(resetMe());
        return Promise.resolve();
    }
}

export const ME_REQUEST = 'ME_REQUEST';
export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_FAILURE = 'ME_FAILURE';

export function fetchMe() {
    let endpoint = '/me';

    return {
        [CALL_API]: {
            types: [ME_REQUEST, ME_SUCCESS, ME_FAILURE],
            endpoint
        }
    }
}

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export function registerApplication(data) {
    const endpoint = '/applications';

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_FAILURE],
            endpoint,
            requireAuth: false
        },
        ...data
    }
}

export const APPLICATIONS_REQUEST = 'APPLICATIONS_REQUEST';
export const APPLICATIONS_SUCCESS = 'APPLICATIONS_SUCCESS';
export const APPLICATIONS_FAILURE = 'APPLICATIONS_FAILURE';

export function fetchApplications(page = 1) {
    const endpoint = `/applications?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [APPLICATIONS_REQUEST, APPLICATIONS_SUCCESS, APPLICATIONS_FAILURE],
            endpoint
        }
    }
}

export const APPLICATION_REQUEST = 'APPLICATION_REQUEST';
export const APPLICATION_SUCCESS = 'APPLICATION_SUCCESS';
export const APPLICATION_FAILURE = 'APPLICATION_FAILURE';

export function fetchApplication(id) {
    const endpoint = `/applications/${id}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [APPLICATION_REQUEST, APPLICATION_SUCCESS, APPLICATION_FAILURE],
            endpoint
        },
        id
    }
}

export const APPLICATION_PATCH_REQUEST = 'APPLICATION_PATCH_REQUEST';
export const APPLICATION_PATCH_SUCCESS = 'APPLICATION_PATCH_SUCCESS';
export const APPLICATION_PATCH_FAILURE = 'APPLICATION_PATCH_FAILURE';

export function patchApplication(id, field, value) {
    const endpoint = `/applications/${id}`;

    return {
        [CALL_API]: {
            method: METHOD_PATCH,
            types: [APPLICATION_PATCH_REQUEST, APPLICATION_PATCH_SUCCESS, APPLICATION_PATCH_FAILURE],
            endpoint
        },
        id,
        [field]: value
    }
}

export const DOCUMENT_UPLOAD_REQUEST = 'DOCUMENT_UPLOAD_REQUEST';
export const DOCUMENT_UPLOAD_SUCCESS = 'DOCUMENT_UPLOAD_SUCCESS';
export const DOCUMENT_UPLOAD_FAILURE = 'DOCUMENT_UPLOAD_FAILURE';

export function uploadDocument(id, body) {
    const endpoint = `/applications/${id}/document`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [DOCUMENT_UPLOAD_REQUEST, DOCUMENT_UPLOAD_SUCCESS, DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        id
    }
}

export const DOCUMENT_DELETE_REQUEST = 'DOCUMENT_DELETE_REQUEST';
export const DOCUMENT_DELETE_SUCCESS = 'DOCUMENT_DELETE_SUCCESS';
export const DOCUMENT_DELETE_FAILURE = 'DOCUMENT_DELETE_FAILURE';

export function deleteDocument(id, docId) {
    const endpoint = `/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [DOCUMENT_DELETE_REQUEST, DOCUMENT_DELETE_SUCCESS, DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        id,
        docId
    }
}

export const LANDLORDS_REQUEST = 'LANDLORDS_REQUEST';
export const LANDLORDS_SUCCESS = 'LANDLORDS_SUCCESS';
export const LANDLORDS_FAILURE = 'LANDLORDS_FAILURE';

export function fetchLandlords(page = 1) {
    const endpoint = `/landlords?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [LANDLORDS_REQUEST, LANDLORDS_SUCCESS, LANDLORDS_FAILURE],
            endpoint
        }
    }
}

export const LANDLORD_REQUEST = 'LANDLORD_REQUEST';
export const LANDLORD_SUCCESS = 'LANDLORD_SUCCESS';
export const LANDLORD_FAILURE = 'LANDLORD_FAILURE';

export function fetchLandlord(id) {
    const endpoint = `/landlords/${id}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [LANDLORD_REQUEST, LANDLORD_SUCCESS, LANDLORD_FAILURE],
            endpoint
        },
        id
    }
}

export const LANDLORD_UPDATE_REQUEST = 'LANDLORD_UPDATE_REQUEST';
export const LANDLORD_UPDATE_SUCCESS = 'LANDLORD_UPDATE_SUCCESS';
export const LANDLORD_UPDATE_FAILURE = 'LANDLORD_UPDATE_FAILURE';

export function updateLandlord(id, object) {
    const endpoint = `/landlords/${id}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [LANDLORD_UPDATE_REQUEST, LANDLORD_UPDATE_SUCCESS, LANDLORD_UPDATE_FAILURE],
            endpoint
        },
        id,
        ...object
    }
}

export const TOKEN_REQUEST = 'TOKEN_REQUEST';
export const TOKEN_SUCCESS = 'TOKEN_SUCCESS';
export const TOKEN_FAILURE = 'TOKEN_FAILURE';

export function fetchTokenData(token, type) {
    let endpoint = `/token?token=${token}&type=${type}`;

    return {
        [CALL_API]: {
            types: [TOKEN_REQUEST, TOKEN_SUCCESS, TOKEN_FAILURE],
            endpoint,
            requireAuth: false
        }
    }
}

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export function signupUser(creds) {
    let endpoint = '/signup';

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE],
            endpoint,
            requireAuth: false
        },
        ...creds
    }
}

export const BRANCHES_REQUEST = 'BRANCHES_REQUEST';
export const BRANCHES_SUCCESS = 'BRANCHES_SUCCESS';
export const BRANCHES_FAILURE = 'BRANCHES_FAILURE';

export function fetchBranches(landlord, page = 1) {
    const endpoint = `/landlord/${landlord}/branch?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [BRANCHES_REQUEST, BRANCHES_SUCCESS, BRANCHES_FAILURE],
            endpoint
        }
    }
}

export const STORE_BRANCH_REQUEST = 'STORE_BRANCH_REQUEST';
export const STORE_BRANCH_SUCCESS = 'STORE_BRANCH_SUCCESS';
export const STORE_BRANCH_FAILURE = 'STORE_BRANCH_FAILURE';

export function storeBranch(landlord, data) {
    const endpoint = `/landlord/${landlord}/branch`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_BRANCH_REQUEST, STORE_BRANCH_SUCCESS, STORE_BRANCH_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_BRANCH_REQUEST = 'UPDATE_BRANCH_REQUEST';
export const UPDATE_BRANCH_SUCCESS = 'UPDATE_BRANCH_SUCCESS';
export const UPDATE_BRANCH_FAILURE = 'UPDATE_BRANCH_FAILURE';

export function updateBranch(landlord, branch, data) {
    const endpoint = `/landlord/${landlord}/branch/${branch}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_BRANCH_REQUEST, UPDATE_BRANCH_SUCCESS, UPDATE_BRANCH_FAILURE],
            endpoint
        },
        ...data
    }
}

export const ADMINS_REQUEST = 'ADMINS_REQUEST';
export const ADMINS_SUCCESS = 'ADMINS_SUCCESS';
export const ADMINS_FAILURE = 'ADMINS_FAILURE';

export function fetchAdmins(landlord, page = 1) {
    const endpoint = `/landlord/${landlord}/admin?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [ADMINS_REQUEST, ADMINS_SUCCESS, ADMINS_FAILURE],
            endpoint
        }
    }
}

export const STORE_ADMIN_REQUEST = 'STORE_ADMIN_REQUEST';
export const STORE_ADMIN_SUCCESS = 'STORE_ADMIN_SUCCESS';
export const STORE_ADMIN_FAILURE = 'STORE_ADMIN_FAILURE';

export function storeAdmin(landlord, data) {
    const endpoint = `/landlord/${landlord}/admin`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_ADMIN_REQUEST, STORE_ADMIN_SUCCESS, STORE_ADMIN_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_ADMIN_REQUEST = 'UPDATE_ADMIN_REQUEST';
export const UPDATE_ADMIN_SUCCESS = 'UPDATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_FAILURE = 'UPDATE_ADMIN_FAILURE';

export function updateAdmin(landlord, admin, data) {
    const endpoint = `/landlord/${landlord}/admin/${admin}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_ADMIN_REQUEST, UPDATE_ADMIN_SUCCESS, UPDATE_ADMIN_FAILURE],
            endpoint
        },
        ...data
    }
}

export const SETTINGS_REQUEST = 'SETTINGS_REQUEST';
export const SETTINGS_SUCCESS = 'SETTINGS_SUCCESS';
export const SETTINGS_FAILURE = 'SETTINGS_FAILURE';

export function fetchSettings(landlord) {
    const endpoint = `/landlord/${landlord}/dlo/settings`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [SETTINGS_REQUEST, SETTINGS_SUCCESS, SETTINGS_FAILURE],
            endpoint
        }
    }
}

export const SETTING_ADD_REQUEST = 'SETTING_ADD_REQUEST';
export const SETTING_ADD_SUCCESS = 'SETTING_ADD_SUCCESS';
export const SETTING_ADD_FAILURE = 'SETTING_ADD_FAILURE';

export function addSetting(landlord, reference, value) {
    const endpoint = `/landlord/${landlord}/dlo/settings/${reference}`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [SETTING_ADD_REQUEST, SETTING_ADD_SUCCESS, SETTING_ADD_FAILURE],
            endpoint
        },
        value
    }
}

export const SETTING_UPDATE_REQUEST = 'SETTING_UPDATE_REQUEST';
export const SETTING_UPDATE_SUCCESS = 'SETTING_UPDATE_SUCCESS';
export const SETTING_UPDATE_FAILURE = 'SETTING_UPDATE_FAILURE';

export function updateSetting(landlord, setting, value) {
    const endpoint = `/landlord/${landlord}/dlo/settings/${setting}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [SETTING_UPDATE_REQUEST, SETTING_UPDATE_SUCCESS, SETTING_UPDATE_FAILURE],
            endpoint
        },
        setting,
        value
    }
}

export const SETTING_DELETE_REQUEST = 'SETTING_DELETE_REQUEST';
export const SETTING_DELETE_SUCCESS = 'SETTING_DELETE_SUCCESS';
export const SETTING_DELETE_FAILURE = 'SETTING_DELETE_FAILURE';

export function deleteSetting(landlord, reference) {
    const endpoint = `/landlord/${landlord}/dlo/settings/${reference}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [SETTING_DELETE_REQUEST, SETTING_DELETE_SUCCESS, SETTING_DELETE_FAILURE],
            endpoint
        },
        reference
    }
}

export const ENGINEERS_REQUEST = 'ENGINEERS_REQUEST';
export const ENGINEERS_SUCCESS = 'ENGINEERS_SUCCESS';
export const ENGINEERS_FAILURE = 'ENGINEERS_FAILURE';

export function fetchEngineers(landlord, page = 1) {
    const endpoint = `/landlord/${landlord}/dlo/engineers`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [ENGINEERS_REQUEST, ENGINEERS_SUCCESS, ENGINEERS_FAILURE],
            endpoint
        }
    }
}

export const ENGINEERS_SYNC_REQUEST = 'ENGINEERS_SYNC_REQUEST';
export const ENGINEERS_SYNC_SUCCESS = 'ENGINEERS_SYNC_SUCCESS';
export const ENGINEERS_SYNC_FAILURE = 'ENGINEERS_SYNC_FAILURE';

export function syncEngineers(landlord) {
    const endpoint = `/landlord/${landlord}/dlo/sync-engineers`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [ENGINEERS_SYNC_REQUEST, ENGINEERS_SYNC_SUCCESS, ENGINEERS_SYNC_FAILURE],
            endpoint
        }
    }
}

export const UPDATE_ENGINEER_REQUEST = 'UPDATE_ENGINEER_REQUEST';
export const UPDATE_ENGINEER_SUCCESS = 'UPDATE_ENGINEER_SUCCESS';
export const UPDATE_ENGINEER_FAILURE = 'UPDATE_ENGINEER_FAILURE';

export function updateEngineer(landlord, engineer, data) {
    const endpoint = `/landlord/${landlord}/dlo/engineers/${engineer}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_ENGINEER_REQUEST, UPDATE_ENGINEER_SUCCESS, UPDATE_ENGINEER_FAILURE],
            endpoint
        },
        engineer,
        ...data
    }
}

export const ENGINEER_DOCUMENT_UPLOAD_REQUEST = 'ENGINEER_DOCUMENT_UPLOAD_REQUEST';
export const ENGINEER_DOCUMENT_UPLOAD_SUCCESS = 'ENGINEER_DOCUMENT_UPLOAD_SUCCESS';
export const ENGINEER_DOCUMENT_UPLOAD_FAILURE = 'ENGINEER_DOCUMENT_UPLOAD_FAILURE';

export function uploadEngineerDocument(landlord, engineer, body) {
    const endpoint = `/landlord/${landlord}/dlo/engineers/${engineer}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [ENGINEER_DOCUMENT_UPLOAD_REQUEST, ENGINEER_DOCUMENT_UPLOAD_SUCCESS, ENGINEER_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        landlord,
        engineer
    }
}

export const ENGINEER_DOCUMENT_DELETE_REQUEST = 'ENGINEER_DOCUMENT_DELETE_REQUEST';
export const ENGINEER_DOCUMENT_DELETE_SUCCESS = 'ENGINEER_DOCUMENT_DELETE_SUCCESS';
export const ENGINEER_DOCUMENT_DELETE_FAILURE = 'ENGINEER_DOCUMENT_DELETE_FAILURE';

export function deleteEngineerDocument(landlord, engineer, docId) {
    const endpoint = `/landlord/${landlord}/dlo/engineers/${engineer}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [ENGINEER_DOCUMENT_DELETE_REQUEST, ENGINEER_DOCUMENT_DELETE_SUCCESS, ENGINEER_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        landlord,
        engineer,
        docId
    }
}

export const NON_ENGINEERS_REQUEST = 'NON_ENGINEERS_REQUEST';
export const NON_ENGINEERS_SUCCESS = 'NON_ENGINEERS_SUCCESS';
export const NON_ENGINEERS_FAILURE = 'NON_ENGINEERS_FAILURE';

export function fetchNonEngineers(landlord, page = 1) {
    const endpoint = `/landlord/${landlord}/dlo/non-engineers`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [NON_ENGINEERS_REQUEST, NON_ENGINEERS_SUCCESS, NON_ENGINEERS_FAILURE],
            endpoint
        }
    }
}

export const STORE_NON_ENGINEER_REQUEST = 'STORE_NON_ENGINEER_REQUEST';
export const STORE_NON_ENGINEER_SUCCESS = 'STORE_NON_ENGINEER_SUCCESS';
export const STORE_NON_ENGINEER_FAILURE = 'STORE_NON_ENGINEER_FAILURE';

export function storeNonEngineer(landlord, data) {
    const endpoint = `/landlord/${landlord}/dlo/non-engineers`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_NON_ENGINEER_REQUEST, STORE_NON_ENGINEER_SUCCESS, STORE_NON_ENGINEER_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_NON_ENGINEER_REQUEST = 'UPDATE_NON_ENGINEER_REQUEST';
export const UPDATE_NON_ENGINEER_SUCCESS = 'UPDATE_NON_ENGINEER_SUCCESS';
export const UPDATE_NON_ENGINEER_FAILURE = 'UPDATE_NON_ENGINEER_FAILURE';

export function updateNonEngineer(landlord, nonEngineer, data) {
    const endpoint = `/landlord/${landlord}/dlo/non-engineers/${nonEngineer}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_NON_ENGINEER_REQUEST, UPDATE_NON_ENGINEER_SUCCESS, UPDATE_NON_ENGINEER_FAILURE],
            endpoint
        },
        nonEngineer,
        ...data
    }
}

export const NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST = 'NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST';
export const NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS = 'NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS';
export const NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE = 'NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE';

export function uploadNonEngineerDocument(landlord, nonEngineer, body) {
    const endpoint = `/landlord/${landlord}/dlo/non-engineers/${nonEngineer}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST, NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS, NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        landlord,
        nonEngineer
    }
}

export const NON_ENGINEER_DOCUMENT_DELETE_REQUEST = 'NON_ENGINEER_DOCUMENT_DELETE_REQUEST';
export const NON_ENGINEER_DOCUMENT_DELETE_SUCCESS = 'NON_ENGINEER_DOCUMENT_DELETE_SUCCESS';
export const NON_ENGINEER_DOCUMENT_DELETE_FAILURE = 'NON_ENGINEER_DOCUMENT_DELETE_FAILURE';

export function deleteNonEngineerDocument(landlord, nonEngineer, docId) {
    const endpoint = `/landlord/${landlord}/dlo/non-engineers/${nonEngineer}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [NON_ENGINEER_DOCUMENT_DELETE_REQUEST, NON_ENGINEER_DOCUMENT_DELETE_SUCCESS, NON_ENGINEER_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        landlord,
        nonEngineer,
        docId
    }
}

export const CONTRACTORS_REQUEST = 'CONTRACTORS_REQUEST';
export const CONTRACTORS_SUCCESS = 'CONTRACTORS_SUCCESS';
export const CONTRACTORS_FAILURE = 'CONTRACTORS_FAILURE';

export function fetchContractors(landlord, page = 1) {
    const endpoint = `/landlord/${landlord}/contractor?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTORS_REQUEST, CONTRACTORS_SUCCESS, CONTRACTORS_FAILURE],
            endpoint
        }
    }
}

export const STORE_CONTRACTOR_REQUEST = 'STORE_CONTRACTOR_REQUEST';
export const STORE_CONTRACTOR_SUCCESS = 'STORE_CONTRACTOR_SUCCESS';
export const STORE_CONTRACTOR_FAILURE = 'STORE_CONTRACTOR_FAILURE';

export function storeContractor(landlord, data) {
    const endpoint = `/landlord/${landlord}/contractor`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_CONTRACTOR_REQUEST, STORE_CONTRACTOR_SUCCESS, STORE_CONTRACTOR_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_LANDLORD_CONTRACTOR_REQUEST = 'UPDATE_LANDLORD_CONTRACTOR_REQUEST';
export const UPDATE_LANDLORD_CONTRACTOR_SUCCESS = 'UPDATE_LANDLORD_CONTRACTOR_SUCCESS';
export const UPDATE_LANDLORD_CONTRACTOR_FAILURE = 'UPDATE_LANDLORD_CONTRACTOR_FAILURE';

export function updateLandlordContractor(landlord, contractor, data) {
    const endpoint = `/landlord/${landlord}/contractor/${contractor}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_LANDLORD_CONTRACTOR_REQUEST, UPDATE_LANDLORD_CONTRACTOR_SUCCESS, UPDATE_LANDLORD_CONTRACTOR_FAILURE],
            endpoint
        },
        ...data
    }
}

export const CONTRACTOR_REQUEST = 'CONTRACTOR_REQUEST';
export const CONTRACTOR_SUCCESS = 'CONTRACTOR_SUCCESS';
export const CONTRACTOR_FAILURE = 'CONTRACTOR_FAILURE';

export function fetchContractor(id) {
    const endpoint = `/contractors/${id}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_REQUEST, CONTRACTOR_SUCCESS, CONTRACTOR_FAILURE],
            endpoint
        },
        id
    }
}

export const UPDATE_CONTRACTOR_REQUEST = 'UPDATE_CONTRACTOR_REQUEST';
export const UPDATE_CONTRACTOR_SUCCESS = 'UPDATE_CONTRACTOR_SUCCESS';
export const UPDATE_CONTRACTOR_FAILURE = 'UPDATE_CONTRACTOR_FAILURE';

export function updateContractor(id, object) {
    const endpoint = `/contractors/${id}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_CONTRACTOR_REQUEST, UPDATE_CONTRACTOR_SUCCESS, UPDATE_CONTRACTOR_FAILURE],
            endpoint
        },
        id,
        ...object
    }
}

export const CONTRACTOR_SETTINGS_REQUEST = 'CONTRACTOR_SETTINGS_REQUEST';
export const CONTRACTOR_SETTINGS_SUCCESS = 'CONTRACTOR_SETTINGS_SUCCESS';
export const CONTRACTOR_SETTINGS_FAILURE = 'CONTRACTOR_SETTINGS_FAILURE';

export function fetchContractorSettings(landlord) {
    const endpoint = `/landlord/${landlord}/contractor/settings`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_SETTINGS_REQUEST, CONTRACTOR_SETTINGS_SUCCESS, CONTRACTOR_SETTINGS_FAILURE],
            endpoint
        }
    }
}

export const CONTRACTOR_SETTING_ADD_REQUEST = 'CONTRACTOR_SETTING_ADD_REQUEST';
export const CONTRACTOR_SETTING_ADD_SUCCESS = 'CONTRACTOR_SETTING_ADD_SUCCESS';
export const CONTRACTOR_SETTING_ADD_FAILURE = 'CONTRACTOR_SETTING_ADD_FAILURE';

export function addContractorSetting(landlord, reference, value) {
    const endpoint = `/landlord/${landlord}/contractor/settings/${reference}`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [CONTRACTOR_SETTING_ADD_REQUEST, CONTRACTOR_SETTING_ADD_SUCCESS, CONTRACTOR_SETTING_ADD_FAILURE],
            endpoint
        },
        value
    }
}

export const CONTRACTOR_SETTING_UPDATE_REQUEST = 'CONTRACTOR_SETTING_UPDATE_REQUEST';
export const CONTRACTOR_SETTING_UPDATE_SUCCESS = 'CONTRACTOR_SETTING_UPDATE_SUCCESS';
export const CONTRACTOR_SETTING_UPDATE_FAILURE = 'CONTRACTOR_SETTING_UPDATE_FAILURE';

export function updateContractorSetting(landlord, setting, value) {
    const endpoint = `/landlord/${landlord}/contractor/settings/${setting}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [CONTRACTOR_SETTING_UPDATE_REQUEST, CONTRACTOR_SETTING_UPDATE_SUCCESS, CONTRACTOR_SETTING_UPDATE_FAILURE],
            endpoint
        },
        setting,
        value
    }
}

export const CONTRACTOR_SETTING_DELETE_REQUEST = 'CONTRACTOR_SETTING_DELETE_REQUEST';
export const CONTRACTOR_SETTING_DELETE_SUCCESS = 'CONTRACTOR_SETTING_DELETE_SUCCESS';
export const CONTRACTOR_SETTING_DELETE_FAILURE = 'CONTRACTOR_SETTING_DELETE_FAILURE';

export function deleteContractorSetting(landlord, reference) {
    const endpoint = `/landlord/${landlord}/contractor/settings/${reference}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [CONTRACTOR_SETTING_DELETE_REQUEST, CONTRACTOR_SETTING_DELETE_SUCCESS, CONTRACTOR_SETTING_DELETE_FAILURE],
            endpoint
        },
        reference
    }
}

export const CONTRACTOR_ADMINS_REQUEST = 'CONTRACTOR_ADMINS_REQUEST';
export const CONTRACTOR_ADMINS_SUCCESS = 'CONTRACTOR_ADMINS_SUCCESS';
export const CONTRACTOR_ADMINS_FAILURE = 'CONTRACTOR_ADMINS_FAILURE';

export function fetchContractorAdmins(contractor, page = 1) {
    const endpoint = `/contractor/${contractor}/admin?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_ADMINS_REQUEST, CONTRACTOR_ADMINS_SUCCESS, CONTRACTOR_ADMINS_FAILURE],
            endpoint
        }
    }
}

export const STORE_CONTRACTOR_ADMIN_REQUEST = 'STORE_CONTRACTOR_ADMIN_REQUEST';
export const STORE_CONTRACTOR_ADMIN_SUCCESS = 'STORE_CONTRACTOR_ADMIN_SUCCESS';
export const STORE_CONTRACTOR_ADMIN_FAILURE = 'STORE_CONTRACTOR_ADMIN_FAILURE';

export function storeContractorAdmin(contractor, data) {
    const endpoint = `/contractor/${contractor}/admin`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_CONTRACTOR_ADMIN_REQUEST, STORE_CONTRACTOR_ADMIN_SUCCESS, STORE_CONTRACTOR_ADMIN_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_CONTRACTOR_ADMIN_REQUEST = 'UPDATE_CONTRACTOR_ADMIN_REQUEST';
export const UPDATE_CONTRACTOR_ADMIN_SUCCESS = 'UPDATE_CONTRACTOR_ADMIN_SUCCESS';
export const UPDATE_CONTRACTOR_ADMIN_FAILURE = 'UPDATE_CONTRACTOR_ADMIN_FAILURE';

export function updateContractorAdmin(contractor, admin, data) {
    const endpoint = `/contractor/${contractor}/admin/${admin}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_CONTRACTOR_ADMIN_REQUEST, UPDATE_CONTRACTOR_ADMIN_SUCCESS, UPDATE_CONTRACTOR_ADMIN_FAILURE],
            endpoint
        },
        ...data
    }
}

export const CONTRACTOR_PREFERENCES_REQUEST = 'CONTRACTOR_PREFERENCES_REQUEST';
export const CONTRACTOR_PREFERENCES_SUCCESS = 'CONTRACTOR_PREFERENCES_SUCCESS';
export const CONTRACTOR_PREFERENCES_FAILURE = 'CONTRACTOR_PREFERENCES_FAILURE';

export function fetchContractorPreferences(contractor) {
    const endpoint = `/contractor/${contractor}/preferences`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_PREFERENCES_REQUEST, CONTRACTOR_PREFERENCES_SUCCESS, CONTRACTOR_PREFERENCES_FAILURE],
            endpoint
        }
    }
}

export const CONTRACTOR_INSURANCES_REQUEST = 'CONTRACTOR_INSURANCES_REQUEST';
export const CONTRACTOR_INSURANCES_SUCCESS = 'CONTRACTOR_INSURANCES_SUCCESS';
export const CONTRACTOR_INSURANCES_FAILURE = 'CONTRACTOR_INSURANCES_FAILURE';

export function fetchContractorInsurances(contractor) {
    const endpoint = `/contractor/${contractor}/insurance`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_INSURANCES_REQUEST, CONTRACTOR_INSURANCES_SUCCESS, CONTRACTOR_INSURANCES_FAILURE],
            endpoint
        }
    }
}

export const STORE_CONTRACTOR_INSURANCE_REQUEST = 'STORE_CONTRACTOR_INSURANCE_REQUEST';
export const STORE_CONTRACTOR_INSURANCE_SUCCESS = 'STORE_CONTRACTOR_INSURANCE_SUCCESS';
export const STORE_CONTRACTOR_INSURANCE_FAILURE = 'STORE_CONTRACTOR_INSURANCE_FAILURE';

export function storeContractorInsurance(contractor, data) {
    const endpoint = `/contractor/${contractor}/insurance`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_CONTRACTOR_INSURANCE_REQUEST, STORE_CONTRACTOR_INSURANCE_SUCCESS, STORE_CONTRACTOR_INSURANCE_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_CONTRACTOR_INSURANCE_REQUEST = 'UPDATE_CONTRACTOR_INSURANCE_REQUEST';
export const UPDATE_CONTRACTOR_INSURANCE_SUCCESS = 'UPDATE_CONTRACTOR_INSURANCE_SUCCESS';
export const UPDATE_CONTRACTOR_INSURANCE_FAILURE = 'UPDATE_CONTRACTOR_INSURANCE_FAILURE';

export function updateContractorInsurance(contractor, insurance, data) {
    const endpoint = `/contractor/${contractor}/insurance/${insurance}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_CONTRACTOR_INSURANCE_REQUEST, UPDATE_CONTRACTOR_INSURANCE_SUCCESS, UPDATE_CONTRACTOR_INSURANCE_FAILURE],
            endpoint
        },
        id: insurance,
        ...data
    }
}

export const INSURANCE_DOCUMENT_UPLOAD_REQUEST = 'INSURANCE_DOCUMENT_UPLOAD_REQUEST';
export const INSURANCE_DOCUMENT_UPLOAD_SUCCESS = 'INSURANCE_DOCUMENT_UPLOAD_SUCCESS';
export const INSURANCE_DOCUMENT_UPLOAD_FAILURE = 'INSURANCE_DOCUMENT_UPLOAD_FAILURE';

export function uploadInsuranceDocument(contractor, insurance, body) {
    const endpoint = `/contractor/${contractor}/insurance/${insurance}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [INSURANCE_DOCUMENT_UPLOAD_REQUEST, INSURANCE_DOCUMENT_UPLOAD_SUCCESS, INSURANCE_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        contractor,
        id: insurance
    }
}

export const INSURANCE_DOCUMENT_DELETE_REQUEST = 'INSURANCE_DOCUMENT_DELETE_REQUEST';
export const INSURANCE_DOCUMENT_DELETE_SUCCESS = 'INSURANCE_DOCUMENT_DELETE_SUCCESS';
export const INSURANCE_DOCUMENT_DELETE_FAILURE = 'INSURANCE_DOCUMENT_DELETE_FAILURE';

export function deleteInsuranceDocument(contractor, insurance, docId) {
    const endpoint = `/contractor/${contractor}/insurance/${insurance}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [INSURANCE_DOCUMENT_DELETE_REQUEST, INSURANCE_DOCUMENT_DELETE_SUCCESS, INSURANCE_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        contractor,
        id: insurance,
        docId
    }
}

export const CONTRACTOR_ENGINEERS_REQUEST = 'CONTRACTOR_ENGINEERS_REQUEST';
export const CONTRACTOR_ENGINEERS_SUCCESS = 'CONTRACTOR_ENGINEERS_SUCCESS';
export const CONTRACTOR_ENGINEERS_FAILURE = 'CONTRACTOR_ENGINEERS_FAILURE';

export function fetchContractorEngineers(contractor, page = 1) {
    const endpoint = `/contractor/${contractor}/engineers`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_ENGINEERS_REQUEST, CONTRACTOR_ENGINEERS_SUCCESS, CONTRACTOR_ENGINEERS_FAILURE],
            endpoint
        }
    }
}

export const CONTRACTOR_ENGINEERS_SYNC_REQUEST = 'CONTRACTOR_ENGINEERS_SYNC_REQUEST';
export const CONTRACTOR_ENGINEERS_SYNC_SUCCESS = 'CONTRACTOR_ENGINEERS_SYNC_SUCCESS';
export const CONTRACTOR_ENGINEERS_SYNC_FAILURE = 'CONTRACTOR_ENGINEERS_SYNC_FAILURE';

export function syncContractorEngineers(contractor) {
    const endpoint = `/contractor/${contractor}/sync-engineers`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_ENGINEERS_SYNC_REQUEST, CONTRACTOR_ENGINEERS_SYNC_SUCCESS, CONTRACTOR_ENGINEERS_SYNC_FAILURE],
            endpoint
        }
    }
}

export const CONTRACTOR_BUSINESS_REQUEST = 'CONTRACTOR_BUSINESS_REQUEST';
export const CONTRACTOR_BUSINESS_SUCCESS = 'CONTRACTOR_BUSINESS_SUCCESS';
export const CONTRACTOR_BUSINESS_FAILURE = 'CONTRACTOR_BUSINESS_FAILURE';

export function fetchContractorBusiness(contractor, page = 1) {
    const endpoint = `/contractor/${contractor}/business`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_BUSINESS_REQUEST, CONTRACTOR_BUSINESS_SUCCESS, CONTRACTOR_BUSINESS_FAILURE],
            endpoint
        }
    }
}

export const CONTRACTOR_BUSINESS_SYNC_REQUEST = 'CONTRACTOR_BUSINESS_SYNC_REQUEST';
export const CONTRACTOR_BUSINESS_SYNC_SUCCESS = 'CONTRACTOR_BUSINESS_SYNC_SUCCESS';
export const CONTRACTOR_BUSINESS_SYNC_FAILURE = 'CONTRACTOR_BUSINESS_SYNC_FAILURE';

export function syncContractorBusiness(contractor) {
    const endpoint = `/contractor/${contractor}/sync-business`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_BUSINESS_SYNC_REQUEST, CONTRACTOR_BUSINESS_SYNC_SUCCESS, CONTRACTOR_BUSINESS_SYNC_FAILURE],
            endpoint
        }
    }
}

export const CONTRACTOR_QUALIFICATIONS_REQUEST = 'CONTRACTOR_QUALIFICATIONS_REQUEST';
export const CONTRACTOR_QUALIFICATIONS_SUCCESS = 'CONTRACTOR_QUALIFICATIONS_SUCCESS';
export const CONTRACTOR_QUALIFICATIONS_FAILURE = 'CONTRACTOR_QUALIFICATIONS_FAILURE';

export function fetchContractorQualifications(contractor) {
    const endpoint = `/contractor/${contractor}/qualification`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_QUALIFICATIONS_REQUEST, CONTRACTOR_QUALIFICATIONS_SUCCESS, CONTRACTOR_QUALIFICATIONS_FAILURE],
            endpoint
        }
    }
}

export const STORE_CONTRACTOR_QUALIFICATION_REQUEST = 'STORE_CONTRACTOR_QUALIFICATION_REQUEST';
export const STORE_CONTRACTOR_QUALIFICATION_SUCCESS = 'STORE_CONTRACTOR_QUALIFICATION_SUCCESS';
export const STORE_CONTRACTOR_QUALIFICATION_FAILURE = 'STORE_CONTRACTOR_QUALIFICATION_FAILURE';

export function storeContractorQualification(contractor, data) {
    const endpoint = `/contractor/${contractor}/qualification`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_CONTRACTOR_QUALIFICATION_REQUEST, STORE_CONTRACTOR_QUALIFICATION_SUCCESS, STORE_CONTRACTOR_QUALIFICATION_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_CONTRACTOR_QUALIFICATION_REQUEST = 'UPDATE_CONTRACTOR_QUALIFICATION_REQUEST';
export const UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS = 'UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS';
export const UPDATE_CONTRACTOR_QUALIFICATION_FAILURE = 'UPDATE_CONTRACTOR_QUALIFICATION_FAILURE';

export function updateContractorQualification(contractor, qualification, data) {
    const endpoint = `/contractor/${contractor}/qualification/${qualification}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_CONTRACTOR_QUALIFICATION_REQUEST, UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS, UPDATE_CONTRACTOR_QUALIFICATION_FAILURE],
            endpoint
        },
        id: qualification,
        ...data
    }
}

export const QUALIFICATION_DOCUMENT_UPLOAD_REQUEST = 'QUALIFICATION_DOCUMENT_UPLOAD_REQUEST';
export const QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS = 'QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS';
export const QUALIFICATION_DOCUMENT_UPLOAD_FAILURE = 'QUALIFICATION_DOCUMENT_UPLOAD_FAILURE';

export function uploadQualificationDocument(contractor, qualification, body) {
    const endpoint = `/contractor/${contractor}/qualification/${qualification}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [QUALIFICATION_DOCUMENT_UPLOAD_REQUEST, QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS, QUALIFICATION_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        contractor,
        id: qualification
    }
}

export const QUALIFICATION_DOCUMENT_DELETE_REQUEST = 'QUALIFICATION_DOCUMENT_DELETE_REQUEST';
export const QUALIFICATION_DOCUMENT_DELETE_SUCCESS = 'QUALIFICATION_DOCUMENT_DELETE_SUCCESS';
export const QUALIFICATION_DOCUMENT_DELETE_FAILURE = 'QUALIFICATION_DOCUMENT_DELETE_FAILURE';

export function deleteQualificationDocument(contractor, qualification, docId) {
    const endpoint = `/contractor/${contractor}/qualification/${qualification}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [QUALIFICATION_DOCUMENT_DELETE_REQUEST, QUALIFICATION_DOCUMENT_DELETE_SUCCESS, QUALIFICATION_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        contractor,
        id: qualification,
        docId
    }
}

export const UPDATE_CONTRACTOR_ENGINEER_REQUEST = 'UPDATE_CONTRACTOR_ENGINEER_REQUEST';
export const UPDATE_CONTRACTOR_ENGINEER_SUCCESS = 'UPDATE_CONTRACTOR_ENGINEER_SUCCESS';
export const UPDATE_CONTRACTOR_ENGINEER_FAILURE = 'UPDATE_CONTRACTOR_ENGINEER_FAILURE';

export function updateContractorEngineer(contractor, engineer, data) {
    const endpoint = `/contractor/${contractor}/engineer/${engineer}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_CONTRACTOR_ENGINEER_REQUEST, UPDATE_CONTRACTOR_ENGINEER_SUCCESS, UPDATE_CONTRACTOR_ENGINEER_FAILURE],
            endpoint
        },
        engineer,
        ...data
    }
}

export const CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST = 'CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST';
export const CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS = 'CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS';
export const CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE = 'CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE';

export function uploadContractorEngineerDocument(contractor, engineer, body) {
    const endpoint = `/contractor/${contractor}/engineer/${engineer}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST, CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS, CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        contractor,
        engineer
    }
}

export const CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST = 'CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST';
export const CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS = 'CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS';
export const CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE = 'CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE';

export function deleteContractorEngineerDocument(contractor, engineer, docId) {
    const endpoint = `/contractor/${contractor}/engineer/${engineer}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST, CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS, CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        contractor,
        engineer,
        docId
    }
}

export const CONTRACTOR_NON_ENGINEERS_REQUEST = 'CONTRACTOR_NON_ENGINEERS_REQUEST';
export const CONTRACTOR_NON_ENGINEERS_SUCCESS = 'CONTRACTOR_NON_ENGINEERS_SUCCESS';
export const CONTRACTOR_NON_ENGINEERS_FAILURE = 'CONTRACTOR_NON_ENGINEERS_FAILURE';

export function fetchContractorNonEngineers(contractor, page = 1) {
    const endpoint = `/contractor/${contractor}/non-engineer`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [CONTRACTOR_NON_ENGINEERS_REQUEST, CONTRACTOR_NON_ENGINEERS_SUCCESS, CONTRACTOR_NON_ENGINEERS_FAILURE],
            endpoint
        }
    }
}

export const STORE_CONTRACTOR_NON_ENGINEER_REQUEST = 'STORE_CONTRACTOR_NON_ENGINEER_REQUEST';
export const STORE_CONTRACTOR_NON_ENGINEER_SUCCESS = 'STORE_CONTRACTOR_NON_ENGINEER_SUCCESS';
export const STORE_CONTRACTOR_NON_ENGINEER_FAILURE = 'STORE_CONTRACTOR_NON_ENGINEER_FAILURE';

export function storeContractorNonEngineer(contractor, data) {
    const endpoint = `/contractor/${contractor}/non-engineer`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_CONTRACTOR_NON_ENGINEER_REQUEST, STORE_CONTRACTOR_NON_ENGINEER_SUCCESS, STORE_CONTRACTOR_NON_ENGINEER_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST = 'UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST';
export const UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS = 'UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS';
export const UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE = 'UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE';

export function updateContractorNonEngineer(contractor, nonEngineer, data) {
    const endpoint = `/contractor/${contractor}/non-engineer/${nonEngineer}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST, UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS, UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE],
            endpoint
        },
        nonEngineer,
        ...data
    }
}

export const CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST = 'CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST';
export const CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS = 'CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS';
export const CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE = 'CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE';

export function uploadContractorNonEngineerDocument(contractor, nonEngineer, body) {
    const endpoint = `/contractor/${contractor}/non-engineer/${nonEngineer}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST, CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS, CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        contractor,
        nonEngineer
    }
}

export const CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST = 'CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST';
export const CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS = 'CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS';
export const CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE = 'CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE';

export function deleteContractorNonEngineerDocument(contractor, nonEngineer, docId) {
    const endpoint = `/contractor/${contractor}/non-engineer/${nonEngineer}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST, CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS, CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        contractor,
        nonEngineer,
        docId
    }
}

export const PROPERTIES_REQUEST = 'PROPERTIES_REQUEST';
export const PROPERTIES_SUCCESS = 'PROPERTIES_SUCCESS';
export const PROPERTIES_FAILURE = 'PROPERTIES_FAILURE';

export function fetchProperties(landlord, page = 1, responsible='all', due='all', query='') {
    const endpoint = `/landlord/${landlord}/property?page=${page}&due=${due}&responsible=${responsible}&q=${query}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [PROPERTIES_REQUEST, PROPERTIES_SUCCESS, PROPERTIES_FAILURE],
            endpoint
        }
    }
}

export const STORE_PROPERTY_REQUEST = 'STORE_PROPERTY_REQUEST';
export const STORE_PROPERTY_SUCCESS = 'STORE_PROPERTY_SUCCESS';
export const STORE_PROPERTY_FAILURE = 'STORE_PROPERTY_FAILURE';

export function storeProperty(landlord, data) {
    const endpoint = `/landlord/${landlord}/property`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [STORE_PROPERTY_REQUEST, STORE_PROPERTY_SUCCESS, STORE_PROPERTY_FAILURE],
            endpoint
        },
        ...data
    }
}

export const UPDATE_PROPERTY_REQUEST = 'UPDATE_PROPERTY_REQUEST';
export const UPDATE_PROPERTY_SUCCESS = 'UPDATE_PROPERTY_SUCCESS';
export const UPDATE_PROPERTY_FAILURE = 'UPDATE_PROPERTY_FAILURE';

export function updateProperty(landlord, property, data) {
    const endpoint = `/landlord/${landlord}/property/${property}`;

    return {
        [CALL_API]: {
            method: METHOD_PUT,
            types: [UPDATE_PROPERTY_REQUEST, UPDATE_PROPERTY_SUCCESS, UPDATE_PROPERTY_FAILURE],
            endpoint
        },
        ...data
    }
}

export const LOOKUP_LOCATION_REQUEST = 'LOOKUP_LOCATION_REQUEST';
export const LOOKUP_LOCATION_SUCCESS = 'LOOKUP_LOCATION_SUCCESS';
export const LOOKUP_LOCATION_FAILURE = 'LOOKUP_LOCATION_FAILURE';

export function lookupLocation(postcode) {
    const endpoint = `/lookup/location?postcode=${postcode}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [LOOKUP_LOCATION_REQUEST, LOOKUP_LOCATION_SUCCESS, LOOKUP_LOCATION_FAILURE],
            endpoint
        }
    }
}

export const CLEAR_LOOKUP_LOCATION = 'CLEAR_LOOKUP_LOCATION';
export function clearLookupLocation() {
    return {
        type: CLEAR_LOOKUP_LOCATION
    };
}

export function fetchContractorProperties(landlord, contractor, page = 1) {
    const endpoint = `/landlord/${landlord}/contractor/${contractor}/properties?page=${page}`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [PROPERTIES_REQUEST, PROPERTIES_SUCCESS, PROPERTIES_FAILURE],
            endpoint
        }
    }
}

export const RETIRE_PROPERTY_REQUEST = 'RETIRE_PROPERTY_REQUEST';
export const RETIRE_PROPERTY_SUCCESS = 'RETIRE_PROPERTY_SUCCESS';
export const RETIRE_PROPERTY_FAILURE = 'RETIRE_PROPERTY_FAILURE';

export function retireProperty(landlord, property) {
    const endpoint = `/landlord/${landlord}/property/${property}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [RETIRE_PROPERTY_REQUEST, RETIRE_PROPERTY_SUCCESS, RETIRE_PROPERTY_FAILURE],
            endpoint
        },
        id: property
    }
}

export const RETIRED_PROPERTIES_REQUEST = 'RETIRED_PROPERTIES_REQUEST';
export const RETIRED_PROPERTIES_SUCCESS = 'RETIRED_PROPERTIES_SUCCESS';
export const RETIRED_PROPERTIES_FAILURE = 'RETIRED_PROPERTIES_FAILURE';

export function fetchRetiredProperties(landlord) {
    const endpoint = `/landlord/${landlord}/property/retired`;

    return {
        [CALL_API]: {
            method: METHOD_GET,
            types: [RETIRED_PROPERTIES_REQUEST, RETIRED_PROPERTIES_SUCCESS, RETIRED_PROPERTIES_FAILURE],
            endpoint
        }
    }
}

export const PROPERTY_DOCUMENT_UPLOAD_REQUEST = 'PROPERTY_DOCUMENT_UPLOAD_REQUEST';
export const PROPERTY_DOCUMENT_UPLOAD_SUCCESS = 'PROPERTY_DOCUMENT_UPLOAD_SUCCESS';
export const PROPERTY_DOCUMENT_UPLOAD_FAILURE = 'PROPERTY_DOCUMENT_UPLOAD_FAILURE';

export function uploadPropertyDocument(landlord, property, body) {
    const endpoint = `/landlord/${landlord}/property/${property}/documents`;

    return {
        [CALL_API]: {
            method: METHOD_POST,
            types: [PROPERTY_DOCUMENT_UPLOAD_REQUEST, PROPERTY_DOCUMENT_UPLOAD_SUCCESS, PROPERTY_DOCUMENT_UPLOAD_FAILURE],
            endpoint,
            type: TYPE_FORM
        },
        body,
        landlord,
        id: property
    }
}

export const PROPERTY_DOCUMENT_DELETE_REQUEST = 'PROPERTY_DOCUMENT_DELETE_REQUEST';
export const PROPERTY_DOCUMENT_DELETE_SUCCESS = 'PROPERTY_DOCUMENT_DELETE_SUCCESS';
export const PROPERTY_DOCUMENT_DELETE_FAILURE = 'PROPERTY_DOCUMENT_DELETE_FAILURE';

export function deletePropertyDocument(landlord, property, docId) {
    const endpoint = `/landlord/${landlord}/property/${property}/documents/${docId}`;

    return {
        [CALL_API]: {
            method: METHOD_DELETE,
            types: [PROPERTY_DOCUMENT_DELETE_REQUEST, PROPERTY_DOCUMENT_DELETE_SUCCESS, PROPERTY_DOCUMENT_DELETE_FAILURE],
            endpoint
        },
        landlord,
        id: property,
        docId
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/actions.js